import { ActionsMetadataV2 } from 'medialoopster/rest';

import {
  ANNOTATION_OPTIONS_LOADED,
  AnnotationOptionsLoaded,
  FETCH_ANNOTATION_OPTIONS,
  FetchAnnotationOptions,
} from './types';

export const fetchAnnotationOptions = (): FetchAnnotationOptions => ({
  type: FETCH_ANNOTATION_OPTIONS,
});
export const annotationOptionsLoaded = (actions: ActionsMetadataV2): AnnotationOptionsLoaded => ({
  type: ANNOTATION_OPTIONS_LOADED,
  payload: {
    actions,
  },
});
